<div class="descriptions-container">
  <!-- Pro -->
  <div class="package-description-container flex flex-col">
    <div class="package-description-title flex flex-row">
      <app-booking-package-badge
        [packageType]="subscriptionsPlanType.Pro"
      ></app-booking-package-badge>
      <div class="flex flex-col">
        <h3>
          {{ '+BOOKING.PLAN.PRO.SPEC.TITLE' | translate }}
        </h3>
        <vi-text color="light">
          {{ '+BOOKING.PLAN.PRO.SPEC.SUBTITLE' | translate }}
        </vi-text>
      </div>
    </div>

    <div class="feature-description-container flex flex-row gap-[24px] lt-md:!hidden">
      <div class="flex flex-col flex-[100%] max-w-[33%]">
        <span class="feature-description__title">{{
          '+BOOKING.PLAN.PRO.SPEC.PERMANENT_INSPECTION.TITLE' | translate
        }}</span>
        <app-translate-list
          [list]="bookingPlansSpecification.permanentInspectionDetails"
        ></app-translate-list>
      </div>
      <div class="flex flex-col flex-[100%] max-w-[33%]">
        <span class="feature-description__title">{{
          '+BOOKING.PLAN.FEATURE.PREDICTIVE_MAINTANANCE' | translate
        }}</span>
        <app-translate-list
          [list]="bookingPlansSpecification.predictiveMaintenanceDetails"
        ></app-translate-list>
      </div>
      <div class="flex flex-col flex-[100%] max-w-[33%]">
        <span class="feature-description__title">{{
          '+BOOKING.PLAN.FEATURE.AUTOMATED_RECOMMENDATIONS' | translate
        }}</span>
        <app-translate-list
          [list]="bookingPlansSpecification.automatedRecommendationsDetails"
        ></app-translate-list>
      </div>
    </div>
    <div class="feature-description-container gap-[24px] flex flex-col lt-md:!hidden">
      <span class="feature-description__title--featured">{{
        '+BOOKING.PLAN.FEATURE.INCLUDED_FUNCTIONS' | translate
      }}</span>
      <div class="flex flex-row gap-[24px] flex-[100%] max-h-[100%]">
        <div class="flex flex-col flex-[100%] gt-md:max-w-[33%] lt-md:max-w-[100%]">
          <app-translate-list
            [list]="bookingPlansSpecification.includedFunctionsDetails_PartOne"
          ></app-translate-list>
        </div>
        <div class="flex flex-col flex-[100%] gt-md:max-w-[33%] lt-md:max-w-[100%]">
          <app-translate-list
            [list]="bookingPlansSpecification.includedFunctionsDetails_PartTwo"
          ></app-translate-list>
        </div>
        <div class="flex flex-col flex-[100%] gt-md:max-w-[33%] lt-md:max-w-[100%]">
          <app-translate-list
            [list]="bookingPlansSpecification.includedFunctionsDetails_PartThree"
          ></app-translate-list>
        </div>
      </div>
    </div>

    <mat-accordion togglePosition="before" class="!hidden lt-md:!block">
      <mat-expansion-panel class="feature-description-container">
        <mat-expansion-panel-header>
          <span class="feature-description__title">{{
            '+BOOKING.PLAN.PRO.SPEC.PERMANENT_INSPECTION.TITLE' | translate
          }}</span>
        </mat-expansion-panel-header>
        <app-translate-list
          [list]="bookingPlansSpecification.permanentInspectionDetails"
        ></app-translate-list>
      </mat-expansion-panel>
      <mat-expansion-panel class="feature-description-container">
        <mat-expansion-panel-header>
          <span class="feature-description__title">{{
            '+BOOKING.PLAN.FEATURE.PREDICTIVE_MAINTANANCE' | translate
          }}</span>
        </mat-expansion-panel-header>
        <app-translate-list
          [list]="bookingPlansSpecification.predictiveMaintenanceDetails"
        ></app-translate-list>
      </mat-expansion-panel>
      <mat-expansion-panel class="feature-description-container">
        <mat-expansion-panel-header>
          <span class="feature-description__title">{{
            '+BOOKING.PLAN.FEATURE.AUTOMATED_RECOMMENDATIONS' | translate
          }}</span>
        </mat-expansion-panel-header>
        <app-translate-list
          [list]="bookingPlansSpecification.automatedRecommendationsDetails"
        ></app-translate-list>
      </mat-expansion-panel>
      <mat-expansion-panel class="feature-description-container">
        <mat-expansion-panel-header>
          <span class="feature-description__title">{{
            '+BOOKING.PLAN.FEATURE.INCLUDED_FUNCTIONS' | translate
          }}</span>
        </mat-expansion-panel-header>
        <div class="flex flex-col">
          <div class="flex flex-col flex-[100%] gt-md:max-w-[33%] lt-md:max-w-[100%]">
            <app-translate-list
              [list]="bookingPlansSpecification.includedFunctionsDetails_PartOne"
            ></app-translate-list>
          </div>
          <div class="flex flex-col flex-[100%] gt-md:max-w-[33%] lt-md:max-w-[100%]">
            <app-translate-list
              [list]="bookingPlansSpecification.includedFunctionsDetails_PartTwo"
            ></app-translate-list>
          </div>
          <div class="flex flex-col flex-[100%] gt-md:max-w-[33%] lt-md:max-w-[100%]">
            <app-translate-list
              [list]="bookingPlansSpecification.includedFunctionsDetails_PartThree"
            ></app-translate-list>
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
  <!-- Plus -->
  <div
    *ngIf="!(authStore.isCompanyFromNetherlandsOrPoland$ | async)"
    class="package-description-container flex flex-col"
  >
    <div class="package-description-title flex flex-row">
      <app-booking-package-badge
        [packageType]="subscriptionsPlanType.Plus"
      ></app-booking-package-badge>
      <div class="flex flex-col">
        <h3>
          {{ '+BOOKING.PLAN.PLUS.SPEC.TITLE' | translate }}
        </h3>
        <vi-text color="light">
          {{ '+BOOKING.PLAN.PLUS.SPEC.SUBTITLE' | translate }}
        </vi-text>
      </div>
    </div>
    <div class="feature-description-container flex flex-row gap-[24px] lt-md:!hidden">
      <div class="flex flex-col flex-[100%] max-w-[25%]">
        <span class="feature-description__title mb-4">{{
          '+BOOKING.PLAN.FEATURE.EXTENDED_PARAMETERS' | translate
        }}</span>
        <app-translate-list
          [list]="bookingPlansSpecification.extendedParametersDetails"
        ></app-translate-list>
      </div>
      <div class="flex flex-col flex-[100%] max-w-[25%]">
        <span class="feature-description__title">{{
          '+BOOKING.PLAN.FEATURE.PARAMETER_COMPARISION' | translate
        }}</span>
        <app-translate-list
          [list]="bookingPlansSpecification.parameterComparisionDetails"
        ></app-translate-list>
      </div>
      <div class="flex flex-col flex-[100%] max-w-[25%]">
        <span class="feature-description__title">{{
          '+BOOKING.PLAN.FEATURE.SYSTEM_OVERVIEW' | translate
        }}</span>
        <app-translate-list
          [list]="bookingPlansSpecification.systemOverviewDetails"
        ></app-translate-list>
      </div>
      <div class="flex flex-col flex-[100%] max-w-[25%]">
        <span class="feature-description__title">{{
          '+BOOKING.PLAN.FEATURE.RECORDING_AND_TRENDING' | translate
        }}</span>
        <app-translate-list
          [list]="bookingPlansSpecification.recordingAndTrendingDetails"
        ></app-translate-list>
      </div>
    </div>
    <mat-accordion togglePosition="before" class="!hidden lt-md:!block">
      <mat-expansion-panel class="feature-description-container">
        <mat-expansion-panel-header>
          <span class="feature-description__title">{{
            '+BOOKING.PLAN.FEATURE.EXTENDED_PARAMETERS' | translate
          }}</span>
        </mat-expansion-panel-header>
        <app-translate-list
          [list]="bookingPlansSpecification.extendedParametersDetails"
        ></app-translate-list>
      </mat-expansion-panel>
      <mat-expansion-panel class="feature-description-container">
        <mat-expansion-panel-header>
          <span class="feature-description__title">{{
            '+BOOKING.PLAN.FEATURE.PARAMETER_COMPARISION' | translate
          }}</span>
        </mat-expansion-panel-header>
        <app-translate-list
          [list]="bookingPlansSpecification.parameterComparisionDetails"
        ></app-translate-list>
      </mat-expansion-panel>
      <mat-expansion-panel class="feature-description-container">
        <mat-expansion-panel-header>
          <span class="feature-description__title">{{
            '+BOOKING.PLAN.FEATURE.SYSTEM_OVERVIEW' | translate
          }}</span>
        </mat-expansion-panel-header>
        <app-translate-list
          [list]="bookingPlansSpecification.systemOverviewDetails"
        ></app-translate-list>
      </mat-expansion-panel>
      <mat-expansion-panel class="feature-description-container">
        <mat-expansion-panel-header>
          <span class="feature-description__title">{{
            '+BOOKING.PLAN.FEATURE.RECORDING_AND_TRENDING' | translate
          }}</span>
        </mat-expansion-panel-header>
        <app-translate-list
          [list]="bookingPlansSpecification.recordingAndTrendingDetails"
        ></app-translate-list>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
  <!-- Basic -->
  <div class="package-description-container flex flex-col">
    <div class="package-description-title flex flex-row">
      <app-booking-package-badge
        [packageType]="subscriptionsPlanType.Basic"
      ></app-booking-package-badge>
      <div class="flex flex-col">
        <h3>
          {{ '+BOOKING.PLAN.BASIC.SPEC.TITLE' | translate }}
        </h3>
        <vi-text color="light">
          {{ '+BOOKING.PLAN.BASIC.SPEC.SUBTITLE' | translate }}
        </vi-text>
      </div>
    </div>
    <div class="feature-description-container flex flex-row gap-[24px] lt-md:!hidden">
      <div class="flex flex-col flex-[100%] max-w-[25%]">
        <span class="feature-description__title">{{
          '+BOOKING.PLAN.FEATURE.QUICK_CHECK_DASHBOARD' | translate
        }}</span>
        <app-translate-list
          [list]="bookingPlansSpecification.quickCheckDashboardDetails"
        ></app-translate-list>
      </div>
      <div class="flex flex-col flex-[100%] max-w-[25%]">
        <span class="feature-description__title">{{
          '+BOOKING.PLAN.FEATURE.GUIDED_COMMISSIONING' | translate
        }}</span>
        <app-translate-list
          [list]="bookingPlansSpecification.guidedCommissioningDetails"
        ></app-translate-list>
      </div>
      <div class="flex flex-col flex-[100%] max-w-[25%]">
        <span class="feature-description__title">{{
          '+BOOKING.PLAN.FEATURE.ERROR_LIST' | translate
        }}</span>
        <app-translate-list
          [list]="bookingPlansSpecification.errorListDetails"
        ></app-translate-list>
      </div>
      <div class="flex flex-col flex-[100%] max-w-[25%]">
        <span class="feature-description__title">{{
          '+BOOKING.PLAN.FEATURE.BASIC_PARAMETERS' | translate
        }}</span>
        <app-translate-list
          [list]="bookingPlansSpecification.basicParametersDetails"
        ></app-translate-list>
      </div>
    </div>
    <mat-accordion togglePosition="before" class="!hidden lt-md:!block">
      <mat-expansion-panel class="feature-description-container">
        <mat-expansion-panel-header>
          <span class="feature-description__title">{{
            '+BOOKING.PLAN.FEATURE.QUICK_CHECK_DASHBOARD' | translate
          }}</span>
        </mat-expansion-panel-header>
        <app-translate-list
          [list]="bookingPlansSpecification.quickCheckDashboardDetails"
        ></app-translate-list>
      </mat-expansion-panel>
      <mat-expansion-panel class="feature-description-container">
        <mat-expansion-panel-header>
          <span class="feature-description__title">{{
            '+BOOKING.PLAN.FEATURE.GUIDED_COMMISSIONING' | translate
          }}</span>
        </mat-expansion-panel-header>
        <app-translate-list
          [list]="bookingPlansSpecification.guidedCommissioningDetails"
        ></app-translate-list>
      </mat-expansion-panel>
      <mat-expansion-panel class="feature-description-container">
        <mat-expansion-panel-header>
          <span class="feature-description__title">{{
            '+BOOKING.PLAN.FEATURE.ERROR_LIST' | translate
          }}</span>
        </mat-expansion-panel-header>
        <app-translate-list
          [list]="bookingPlansSpecification.errorListDetails"
        ></app-translate-list>
      </mat-expansion-panel>
      <mat-expansion-panel class="feature-description-container">
        <mat-expansion-panel-header>
          <span class="feature-description__title">{{
            '+BOOKING.PLAN.FEATURE.BASIC_PARAMETERS' | translate
          }}</span>
        </mat-expansion-panel-header>
        <app-translate-list
          [list]="bookingPlansSpecification.basicParametersDetails"
        ></app-translate-list>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</div>
